import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { sweetAlert } from "../../Common/Utills/Utills";
//   import UpdatePartyName from "./UpdatePartyName";
import moment from "moment";
import Pagination from "../../Common/Pagination/Pagination";
import { CSSTransition } from "react-transition-group";
import AddRegion from "./AddRegion";
import UpdateRegion from "./UpdateRegion";
import Swal from "sweetalert2";
import _ from "lodash";

const RegionList = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(startItem + rowData.length - 1, totalRecords);
  const [discom, setDiscom] = useState([]);
  const [discomId, setDiscomId] = useState("");
  const formRef = useRef(null);
  const [filterCriteria, setfilterCriteria] = useState({
    region_name: "",
    discom_id: ""
  });

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };

  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  const handleDiscomChange = (e) => {
    const discomid = e.target.value !== "" ? parseInt(e.target.value) : "";
    setDiscomId(discomid);

    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      discom_id: discomid,
    }));
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1);
  };

  const handleFilterChange = (name, value) => {
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      [name]: value,
    }));
  };

  const updateHandleChange = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setselectedRowsData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      console.error("Event or event.target is undefined");
    }
  };

  const getData = async () => {
    let BASE_URL = SERVER_URL + `/api/region/all-region-list/${user_id}`;
    const nonEmptyFilterCriteria = Object.fromEntries(
      Object.entries(filterCriteria).filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
    );
    const options = {
      whereFilters: nonEmptyFilterCriteria,
      skip: currentPage,
      take: pageSize,
    };
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(result.data);
    } else {
      setRowData([]);
    }
  };

  useEffect(() => {
    const fecthDebounced = _.debounce(getData, 500);
    fecthDebounced();
    return () => {
      fecthDebounced.cancel();
    };
  }, [currentPage, pageSize, filterCriteria]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateData(updatedData);
  };

  const onSelectionChanged = useCallback((event) => {
    const selectedNodes = event.api.getSelectedNodes();
    setRmvBtn(selectedNodes.length > 1);
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
  }, []);

  const deleteRow = async (id) => {
    const message = "Do you want to delete this region name!";

    const result = await sweetAlert(message);

    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL = SERVER_URL + `/api/region/region-list/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const addDataToModal = (rowData) => {
    setselectedRowsData(rowData);
  };

  const updateData = async (rowData) => {
    const { id, discom_name } = rowData;
    let BASE_URL = SERVER_URL + `/api/region/region-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id, discom_name }),
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const colDefs = useMemo(
    () => [
      {
        headerName: "S. No",
        valueGetter: (params) => {
          const currentPageContext = params.context.currentPage;
          const pageSizeContext = params.context.pageSize;
          return (
            (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
          );
        },
        width: 150,
      },
      {
        headerName: "Discom Name",
        field: "discomList.discom_name",
        editable: false,
        width: 205,
      },
      {
        headerName: "Region Name",
        field: "region_name",
        editable: false,
        width: 205,
      },
      {
        headerName: "Actions",
        cellRenderer: (params) => (
          <>
            <button
              className="btn btn-outline-danger btn-sm"
              onClick={() => deleteRow(params.data.id)}
            >
              <i className="mdi mdi-delete" />
            </button>{" "}
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => addDataToModal(params.data)}
              data-toggle="modal"
              data-target="#updateModal"
            >
              <i className="mdi mdi-note-edit-outline" />
            </button>
          </>
        ),
        minWidth: 205,
      },
    ],
    []
  );

  const sortingOrder = useMemo(() => ["desc", "asc", null], []);
  const defaultColDef = useMemo(
    () => ({
      filter: true,
      flex: 1,
      editable: true,
      headerPosition: "sticky",
    }),
    []
  );

  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);

  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({ region_name: "", discom_id: "" });
    setDiscomId("")
  };

  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });

  const getDiscom = async () => {
    const BASE_URL = SERVER_URL + `/api/discom/all-discoms/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if(res.ok){
      setDiscom(result.data);
    }else{
      setDiscom([]);
    }
  };

  useEffect(() => {
    getDiscom();
  }, []);
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Region List Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3">
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add Region
              </button>
            </div>

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div className="search mb-3">
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <select
                    className="form-control form-control-lg"
                    onChange={handleDiscomChange}
                    value={discomId}
                    id="discom"
                    required
                  >
                    <option value="">Select Discom</option>
                    {discom &&
                      discom?.length > 0 &&
                      discom?.map((item, id) => {
                        return (
                          <option
                            value={item.id}
                            key={id}
                          >{`${item.discom_name}`}</option>
                        );
                      })}
                  </select>
                </div>
              </div>
              <div className="col-md-4" style={{ display: "flex" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Region name"
                  value={filterCriteria.region_name}
                  onChange={(e) =>
                    handleFilterChange("region_name", e.target.value)
                  }
                />
              </div>
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                context={{ currentPage, pageSize }}
                // domLayout="autoHeight"
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                // gridOptions={gridOptions}
                rowSelection={"multiple"} // For row selection
                suppressRowClickSelection={true} // For row selection
                suppressCellSelection={true} // For row selection
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </div>
          <AddRegion
            //   setimgfile={setimgfile}
            formRef={formRef}
            getData={getData}
          />
          <UpdateRegion
            selectedRowsData={selectedRowsData}
            setselectedRowsData={setselectedRowsData}
            updateHandleChange={updateHandleChange}
            getData={getData}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default RegionList;
